import { List } from 'immutable';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import cardsTemplateImageUrl from 'bender-url!../../img/templates/cards.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import contentTemplateImageUrl from 'bender-url!../../img/templates/content.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import defaultTemplateImageUrl from 'bender-url!../../img/templates/default.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import minimalTemplateImageUrl from 'bender-url!../../img/templates/minimal.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import tilesTemplateImageUrl from 'bender-url!../../img/templates/tiles.png';

// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import cardsDesktopImageUrl from 'bender-url!../../img/templateDevicePreview/cards.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import contentDesktopImageUrl from 'bender-url!../../img/templateDevicePreview/content.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import minimalDesktopImageUrl from 'bender-url!../../img/templateDevicePreview/minimal.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import tilesDesktopImageUrl from 'bender-url!../../img/templateDevicePreview/tiles.png';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/templa... Remove this comment to see the full error message
import defaultDesktopImageUrl from 'bender-url!../../img/templateDevicePreview/default.png';
export const TEMPLATE_TYPE = {
  CARDS: 'cards',
  // icon/image: no, color: yes, articles: no
  CONTENT: 'content',
  // icon/image: yes, color: yes, articles: yes
  DEFAULT: 'default',
  // icon/image no, color: no, articles: no, clicking on categories disabled
  MINIMAL: 'minimal',
  // icon/image: yes, color: yes, articles: no
  TILES: 'tiles' // icon/image: yes, color: yes, articles: no
};
export const TEMPLATE_IMAGE_URL = {
  [TEMPLATE_TYPE.CARDS]: cardsTemplateImageUrl,
  [TEMPLATE_TYPE.CONTENT]: contentTemplateImageUrl,
  [TEMPLATE_TYPE.DEFAULT]: defaultTemplateImageUrl,
  [TEMPLATE_TYPE.MINIMAL]: minimalTemplateImageUrl,
  [TEMPLATE_TYPE.TILES]: tilesTemplateImageUrl
};
export const DEVICE_PREVIEW_IMAGE_URL = {
  [TEMPLATE_TYPE.CARDS]: cardsDesktopImageUrl,
  [TEMPLATE_TYPE.CONTENT]: contentDesktopImageUrl,
  [TEMPLATE_TYPE.MINIMAL]: minimalDesktopImageUrl,
  [TEMPLATE_TYPE.TILES]: tilesDesktopImageUrl,
  [TEMPLATE_TYPE.DEFAULT]: defaultDesktopImageUrl
};
export const TEMPLATE_TYPES = [TEMPLATE_TYPE.CONTENT, TEMPLATE_TYPE.TILES, TEMPLATE_TYPE.MINIMAL, TEMPLATE_TYPE.CARDS, TEMPLATE_TYPE.DEFAULT];

// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
export const ORDERED_TEMPLATE_TYPES = new List(TEMPLATE_TYPES);